import React, { useState } from 'react';
import ActionSheet from 'devextreme-react/action-sheet';
import { getBFIExperienceActions, executeBFIExperienceAction } from '../ExperienceFunctions';
import { InformModal } from '../../../common/SharedComponents';

export const BFIExperienceActionsButton = ({ experience, location: Location }) => {
    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, exp) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getBFIExperienceActions(exp, location);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeBFIExperienceAction(e.itemData);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    if (!experience) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${experience.id}_${experience.principalId}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, experience)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
